export default "__VITE_ASSET__BbNTiVOW__$_?assetResource__"